import { render, staticRenderFns } from "./r-title.vue?vue&type=template&id=f26420a0&scoped=true&"
import script from "./r-title.vue?vue&type=script&lang=js&"
export * from "./r-title.vue?vue&type=script&lang=js&"
import style0 from "./r-title.vue?vue&type=style&index=0&id=f26420a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26420a0",
  null
  
)

export default component.exports